"use strict";
export const validateDeliveryAddress = validate10;
export default validate10;
const schema11 = {
    "$schema": "http://json-schema.org/draft-07/schema",
    "$id": "http://example.com/example.json",
    "type": "object",
    "required": ["addressType", "postalAddress", "postalCode", "postalPlace", "price", "recipient", "selectedShippingName"],
    "properties": {
        "addressType": {"$id": "#/properties/addressType", "type": "string"},
        "postalAddress": {"$id": "#/properties/postalAddress", "type": "string"},
        "postalCode": {"$id": "#/properties/postalCode", "type": "string"},
        "postalPlace": {"$id": "#/properties/postalPlace", "type": "string"},
        "price": {"$id": "#/properties/price", "type": ["integer", "number"]},
        "recipient": {"$id": "#/properties/recipient", "type": "string"},
        "selectedShippingName": {"$id": "#/properties/selectedShippingName", "type": "string"}
    }
};

function validate10(data, {instancePath = "", parentData, parentDataProperty, rootData = data} = {}) {/*# sourceURL="http://example.com/example.json" */
    ;let vErrors = null;
    let errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        if (data.addressType === undefined) {
            const err0 = {
                instancePath,
                schemaPath: "#/required",
                keyword: "required",
                params: {missingProperty: "addressType"},
                message: "must have required property '" + "addressType" + "'"
            };
            if (vErrors === null) {
                vErrors = [err0];
            } else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (data.postalAddress === undefined) {
            const err1 = {
                instancePath,
                schemaPath: "#/required",
                keyword: "required",
                params: {missingProperty: "postalAddress"},
                message: "must have required property '" + "postalAddress" + "'"
            };
            if (vErrors === null) {
                vErrors = [err1];
            } else {
                vErrors.push(err1);
            }
            errors++;
        }
        if (data.postalCode === undefined) {
            const err2 = {
                instancePath,
                schemaPath: "#/required",
                keyword: "required",
                params: {missingProperty: "postalCode"},
                message: "must have required property '" + "postalCode" + "'"
            };
            if (vErrors === null) {
                vErrors = [err2];
            } else {
                vErrors.push(err2);
            }
            errors++;
        }
        if (data.postalPlace === undefined) {
            const err3 = {
                instancePath,
                schemaPath: "#/required",
                keyword: "required",
                params: {missingProperty: "postalPlace"},
                message: "must have required property '" + "postalPlace" + "'"
            };
            if (vErrors === null) {
                vErrors = [err3];
            } else {
                vErrors.push(err3);
            }
            errors++;
        }
        if (data.price === undefined) {
            const err4 = {
                instancePath,
                schemaPath: "#/required",
                keyword: "required",
                params: {missingProperty: "price"},
                message: "must have required property '" + "price" + "'"
            };
            if (vErrors === null) {
                vErrors = [err4];
            } else {
                vErrors.push(err4);
            }
            errors++;
        }
        if (data.recipient === undefined) {
            const err5 = {
                instancePath,
                schemaPath: "#/required",
                keyword: "required",
                params: {missingProperty: "recipient"},
                message: "must have required property '" + "recipient" + "'"
            };
            if (vErrors === null) {
                vErrors = [err5];
            } else {
                vErrors.push(err5);
            }
            errors++;
        }
        if (data.selectedShippingName === undefined) {
            const err6 = {
                instancePath,
                schemaPath: "#/required",
                keyword: "required",
                params: {missingProperty: "selectedShippingName"},
                message: "must have required property '" + "selectedShippingName" + "'"
            };
            if (vErrors === null) {
                vErrors = [err6];
            } else {
                vErrors.push(err6);
            }
            errors++;
        }
        if (data.addressType !== undefined) {
            if (typeof data.addressType !== "string") {
                const err7 = {
                    instancePath: instancePath + "/addressType",
                    schemaPath: "#/properties/addressType/type",
                    keyword: "type",
                    params: {type: "string"},
                    message: "must be string"
                };
                if (vErrors === null) {
                    vErrors = [err7];
                } else {
                    vErrors.push(err7);
                }
                errors++;
            }
        }
        if (data.postalAddress !== undefined) {
            if (typeof data.postalAddress !== "string") {
                const err8 = {
                    instancePath: instancePath + "/postalAddress",
                    schemaPath: "#/properties/postalAddress/type",
                    keyword: "type",
                    params: {type: "string"},
                    message: "must be string"
                };
                if (vErrors === null) {
                    vErrors = [err8];
                } else {
                    vErrors.push(err8);
                }
                errors++;
            }
        }
        if (data.postalCode !== undefined) {
            if (typeof data.postalCode !== "string") {
                const err9 = {
                    instancePath: instancePath + "/postalCode",
                    schemaPath: "#/properties/postalCode/type",
                    keyword: "type",
                    params: {type: "string"},
                    message: "must be string"
                };
                if (vErrors === null) {
                    vErrors = [err9];
                } else {
                    vErrors.push(err9);
                }
                errors++;
            }
        }
        if (data.postalPlace !== undefined) {
            if (typeof data.postalPlace !== "string") {
                const err10 = {
                    instancePath: instancePath + "/postalPlace",
                    schemaPath: "#/properties/postalPlace/type",
                    keyword: "type",
                    params: {type: "string"},
                    message: "must be string"
                };
                if (vErrors === null) {
                    vErrors = [err10];
                } else {
                    vErrors.push(err10);
                }
                errors++;
            }
        }
        if (data.price !== undefined) {
            let data4 = data.price;
            if (!((typeof data4 == "number") && (isFinite(data4)))) {
                const err11 = {
                    instancePath: instancePath + "/price",
                    schemaPath: "#/properties/price/type",
                    keyword: "type",
                    params: {type: schema11.properties.price.type},
                    message: "must be integer,number"
                };
                if (vErrors === null) {
                    vErrors = [err11];
                } else {
                    vErrors.push(err11);
                }
                errors++;
            }
        }
        if (data.recipient !== undefined) {
            if (typeof data.recipient !== "string") {
                const err12 = {
                    instancePath: instancePath + "/recipient",
                    schemaPath: "#/properties/recipient/type",
                    keyword: "type",
                    params: {type: "string"},
                    message: "must be string"
                };
                if (vErrors === null) {
                    vErrors = [err12];
                } else {
                    vErrors.push(err12);
                }
                errors++;
            }
        }
        if (data.selectedShippingName !== undefined) {
            if (typeof data.selectedShippingName !== "string") {
                const err13 = {
                    instancePath: instancePath + "/selectedShippingName",
                    schemaPath: "#/properties/selectedShippingName/type",
                    keyword: "type",
                    params: {type: "string"},
                    message: "must be string"
                };
                if (vErrors === null) {
                    vErrors = [err13];
                } else {
                    vErrors.push(err13);
                }
                errors++;
            }
        }
    } else {
        const err14 = {
            instancePath,
            schemaPath: "#/type",
            keyword: "type",
            params: {type: "object"},
            message: "must be object"
        };
        if (vErrors === null) {
            vErrors = [err14];
        } else {
            vErrors.push(err14);
        }
        errors++;
    }
    validate10.errors = vErrors;
    return errors === 0;
}